export default "__VITE_ASSET__DIddeIeB__"